import React from 'react';

import {pure} from 'recompose';

import './CircleButton.css';

const CircleButton = (props) => (
  <button
    className={"circle-button"}
    title={props.title}
    onClick={props.onClick}
    disabled={props.disabled}
    style={{
      backgroundColor: props.active? '#4fc3ea' : '#00a8a2',
    }}
  >
    <div className="button-child-container">
      {props.children}
    </div>
  </button>
)

CircleButton.defaultProps = {
  active: false,
}

export default pure(CircleButton);



// WEBPACK FOOTER //
// ./src/components/CirleButton.js